// Adószám xxxxxxxx-y-zz formában
export default function() {
  return /^([0-9]{8}[\- ]?[1-5][\- ]?[0-5][0-9])$/;
};